import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
    document.body.classList.remove('mobile-menu-open');
  }, [location]);

  // Toggle mobile menu and body scroll
  const toggleMobileMenu = () => {
    const newState = !isMobileMenuOpen;
    setIsMobileMenuOpen(newState);
    
    if (newState) {
      document.body.classList.add('mobile-menu-open');
    } else {
      document.body.classList.remove('mobile-menu-open');
    }
  };

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobileMenuOpen && !event.target.closest('.navbar')) {
        setIsMobileMenuOpen(false);
        document.body.classList.remove('mobile-menu-open');
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isMobileMenuOpen]);

  // Clean up body class on unmount
  useEffect(() => {
    return () => {
      document.body.classList.remove('mobile-menu-open');
    };
  }, []);

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          {/* Brand removed to avoid menu interference */}
        </div>
        
        <button 
          className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        
        <ul className={`navbar-menu ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <li>
            <Link to="/" className={isActive('/')}>
              <img src="/images/hello.png" alt="Hello" className="nav-icon" />
              Ciao
            </Link>
          </li>
          <li>
            <Link to="/southington" className={isActive('/southington')}>
              <img src="/images/apple.png" alt="Apple" className="nav-icon" />
              06489
            </Link>
          </li>
          <li>
            <Link to="/recipes" className={isActive('/recipes')}>
              <img src="/images/pane.png" alt="Pane" className="nav-icon" />
              Pane
            </Link>
          </li>
          <li>
            <Link to="/wine" className={isActive('/wine')}>
              <img src="/images/wine.png" alt="Wine" className="nav-icon" />
              Vino
            </Link>
          </li>
          <li>
            <Link to="/futbol" className={isActive('/futbol')}>
              <img src="/images/futbol.png" alt="Futbol" className="nav-icon" />
              Futbol
            </Link>
          </li>
          <li>
            <Link to="/jeep" className={isActive('/jeep')}>
              <img src="/images/jeep.png" alt="Jeep" className="nav-icon" />
              Jeep
            </Link>
          </li>
          <li>
            <Link to="/genes" className={isActive('/genes')}>
              <img src="/images/genes.svg" alt="Gene's" className="nav-icon" />
              Gene's
            </Link>
          </li>
          <li>
            <Link to="/family-tree" className={isActive('/family-tree')}>
              <img src="/images/rossetti.png" alt="Rossetti" className="nav-icon" />
              Rossetti
            </Link>
          </li>
          <li>
            <Link to="/calendar" className={isActive('/calendar')}>
              <i className="fas fa-calendar-alt nav-icon"></i>
              Calendar
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;
